import jsdoc from "refractor/jsdoc";
export default jsdoc;